import React, { Fragment } from 'react';
import _ from 'lodash';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';

import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';

import NumberField from '../../../Base/NumberField';

const PUMP_TYPES = ["Unknown", "Centrifugal", "Vac-Strip", "Reciprocating",
	"Screw", "Gear", "Eductors / Ejector", "Peristaltic", "Lobe", "Piston",
	"Deepwell", "BDPS", "Desmi Rotordynamic", "Marflex Deepwell",
	"Hydraulic Driven", "Framo"];

class Pumps extends React.Component {
    constructor(props) {
        super(props);
        
        this.addRow = this.addRow.bind(this);
        this.removeRow = this.removeRow.bind(this);
    }

    addRow() {
        const pumps = _.cloneDeep(this.props.pumps);

        pumps.push({
            type: '',
            quantity: '',
            capacity: '',
        });

        this.props.changeField({ field: `pumps.${this.props.type}`, value: pumps });
    }

    removeRow(index) {
        const pumps = _.cloneDeep(this.props.pumps);
        pumps.splice(index, 1);
        this.props.changeField({ field: `pumps.${this.props.type}`, value: pumps });
    }

    componentDidUpdate() {
        if (this.props.pumps.length === 0) {
            this.addRow();
        }
    }

    render() {
        const { changeField, getError, pumps, confirmed, modifiedFields, underStyle } = this.props;

        return (
            <Fragment>
                {
                    pumps.map((pump, index) => (
                        <div key={index} className='row'>
                            <div className='col-xs-4'>
                                <SelectField
                                    value={pump.type || ''}
                                    onChange={(e, i, value) => {
                                        changeField([{
                                            field: `pumps.${this.props.type}[${index}].type`,
                                            value,
                                        }]);
                                    }}
                                    disabled={confirmed}
                                    errorText={getError && getError(`pumps.${this.props.type}[${index}].type`)}
                                    maxHeight={200}
                                    name='type'
                                    floatingLabelText={`${_.capitalize(this.props.type)} pump type`}
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    fullWidth
                                    autoWidth
                                    underlineStyle={modifiedFields && modifiedFields.includes(`pumps.${this.props.type}[${index}].type`) ? underStyle : null}

                                >
                                    {
                                        PUMP_TYPES.map(type => {
                                            return (<MenuItem
                                                key={type}
                                                value={type}
                                                primaryText={type}
                                            />);
                                        })
                                    }
                                </SelectField>
                            </div>
                            <div className='col-xs-4'>
                                <NumberField
                                    name={`pumps.${this.props.type}[${index}].quantity`}
                                    floatingLabelText='Quantity'
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    value={pump.quantity || ''}
                                    fullWidth
                                    disabled={!pump.type}
                                    errorText={getError && getError(`pumps.${this.props.type}[${index}].quantity`)}
                                    onChange={(e, value) => {
                                        changeField({
                                            field: `pumps.${this.props.type}[${index}].quantity`,
                                            value,
                                            type: 'number',
                                        });
                                    }}

                                    underlineStyle={modifiedFields && modifiedFields.includes(`pumps.${this.props.type}[${index}].quantity`) ? underStyle : null}

                                />
                            </div>
                            <div className='col-xs-3'>
                                <NumberField
                                    name={`pumps.${this.props.type}[${index}].capacity`}
                                    floatingLabelText='Capacity, m3/hour'
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    value={pump.capacity || ''}
                                    fullWidth
                                    floatNumber
                                    disabled={!pump.type}
                                    errorText={getError && getError(`pumps.${this.props.type}[${index}].capacity`)}
                                    onChange={(e, value) => {
                                        changeField({
                                            field: `pumps.${this.props.type}[${index}].capacity`,
                                            value,
                                            type: 'number',
                                        });
                                    }}

                                    underlineStyle={modifiedFields && modifiedFields.includes(`pumps.${this.props.type}[${index}].capacity`) ? underStyle : null}
                                />
                            </div>
                            <div className='col-xs-1 middle-xs center-xs' style={{ display: 'flex' }}>
                                <div style={{ margin: '25px 0 0 0' }}>
                                    {index === 0 && (
                                        <IconButton
                                            disabled={confirmed}
                                            onClick={this.addRow}
                                        >
                                            <ContentAddIcon color='green' />
                                        </IconButton>
                                    )}
                                    {index !== 0 && (
                                        <IconButton
                                            disabled={confirmed}
                                            onClick={() => {
                                                this.removeRow(index);
                                            }}
                                        >
                                            <ContentRemoveIcon color='red' />
                                        </IconButton>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                }
            </Fragment>
        );
    }
}

export default Pumps;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Pumps.jsx